import React, { useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useRouteMatch } from 'react-router-dom'

import { TableHelper } from '../../../../tables'
import { UserTable } from '../../../../tables/user-table'

const Users = observer(() => {
  const match = useRouteMatch<any>('/content/topics/:id/users')
  const topicID = Number(match?.params?.id)

  const [tableHelper] = useState(new TableHelper('list_topic_users', 'users', 'topics', topicID))

  return <UserTable tableHelper={tableHelper} />
})

export const TopicsUsersTab = (props: any) => {
  const { id } = props
  return {
    name: 'Users',
    path: `/content/topics/${id}/users`,
    component: () => <Users />,
  }
}
